import { injectIntl } from 'react-intl';

import Progress from './Progress';

export default injectIntl(Progress);
